<template>
  <div class="abs" id="About">
    <p class="title" name="About">About Us</p>
    <div class="main">
      <el-row>
        <el-col :span="9" :xs="24" class="abs-img">
          <img :src="require(`@images/abs_1.png`)" />
        </el-col>
        <el-col class="abs-text-info" :span="14" :xs="24">
          <div class="abs-text-content">
            <p class="descript">Based in Singapore, GamAI is founded by experienced adtech and mobile gaming veterans. We are proud of our talented team and what we have achieved, and all our products & technology are developed in-house from scratch. </p>
          </div>
        </el-col>
      </el-row>
      <div class="abs-values">
        <h4 class="sub-title">GamAI missions</h4>
        <el-carousel type="card" :interval="4000" height="220px" class="abs-values-col">
          <el-carousel-item v-for="(item, index) in items" :key="index" :style="`${item.bg}`">
            <h3><span>{{ item.desc }}</span></h3>
          </el-carousel-item>
        </el-carousel>
      </div>
      <h4 class="sub-title">Our Office</h4>
      <div class="abs-office">
        <el-row>
          <el-col :span="14" :xs="24">
            <div class="abs-off-img">
              <img width="90%" :src="require(`@images/abs_3.jpeg`)" />
            </div>
          </el-col>
          <el-col :span="10" :xs="24">
            <div class="abs-off-text">
              <h5 class="abs-off-title">Singapore</h5>
              <p class="abs-off-desc">21 merchant road, #07-02, Royal Merukh S.E.A Building, Singapore 058267</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "About",
  data: function () {
    return {
      items: [
        {
          desc: 'Develop games which entertain the world',
          bg: 'background-image: linear-gradient(to top, #0c3483 0%, #a2b6df 100%, #6b8cce 100%, #a2b6df 100%);',
        },
        {
          desc: 'Provides a World class mobile monetization platform for developers to earn more revenue',
          bg: 'background-image: linear-gradient(to right, #243949 0%, #517fa4 100%);'
        },
        {
          desc: 'Provide advertisers with quality performing global in-app inventory',
          bg: 'background-image: linear-gradient(-20deg, #2b5876 0%, #4e4376 100%);'
        }
      ]
    };
  }
};
</script>
<style>
  .el-carousel__item h3 {
    color: #ffffff;
    font-size: 20px;
    opacity: 0.75;
    /* line-height: 200px; */
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
    margin: 0 auto;
    padding: 0 60px;
  }
  
  .el-carousel__item:child(0) {
    background-image: linear-gradient(to top, #9890e3 0%, #b1f4cf 100%);
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
</style>
<style lang="scss" scoped>
.abs {
  background: #ffffff;
  position: relative;
  box-shadow: $section-box-shadow;
  padding: 1px 0 px2rem(40) 0;
  .main {
    max-width: px2rem(900);
    .el-row {
      margin: px2rem(50) auto;
      min-height: px2rem(250);
      .abs-img {
        justify-content: center;
        align-items: center;
        display: flex;
        overflow: hidden;
        height: 100%;
        img {
          width: 90%;
          border-radius: px2rem(15);
          object-fit: contain;
        }
      }
      .abs-text-info{
        height: 100%;
        justify-content: center;
        align-items: center;
        display: flex;
        .abs-text-content {
          text-align: left;
          padding: 0 px2rem(20);
        }
      }
    }
    .abs-sp-title {
      font-size: px2rem(20);
      color: $--color-primary;
      text-align: left;
      margin: px2rem(80) 0;
      font-weight: bolder;
      margin-top: px2rem(100);
      font-family: "Helvetica Neue",sans-serif;
    }
    .abs-values {
      margin: 0 auto;
      .abs-values-col {
        margin-top: px2rem(40);
      }
    }
    .abs-office {
      max-width: px2rem(700);
      margin: 0 auto;
      margin-top: 0px;
      // background: #f5f5f5;
      border-radius: 5px;
      // box-shadow: 0px 0px 5px 5px rgba(0, 0, 0, 0.1);
      .abs-off-title {
        text-align: left;
        font-size: px2rem(15);
        margin: 0 auto;
      }
      .abs-off-desc {
        font-size: px2rem(12);
        letter-spacing: 1px;
        line-height: 1.1em;
        text-align: left;
        color: $--color-primary;
      }
      .abs-off-img {
        max-width: 500px;
        text-align: left;
      }
    }
  }
}
</style>